<template lang="pug">
div
  div(v-if="loading" class="text-center pt-5")
    sdo-loader
  data-wrapper(
    v-else
    :loading="loading"
    :skeleton-items-count="4"
    :has-items="!!students.length"
    skeleton-type="paragraph"
    :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
  )
    template(#no-data)
      v-alert(
        type="info" prominent text
      ).mx-auto Еще нет обучающихся
    template(#default)
      v-list.mx-4
        v-list-item(
          v-for="student in students" :key="student.id"
          :to=`{
              name: "StudentReview",
              params: { id: student.id },
            }`
        )
          v-list-item-content
            v-list-item-title.text-h6: strong {{ student.fio }}
            v-chip-group(v-if="student.number")
              tooltip-wrap(text="Сертификат")
                v-chip(color="primary" label small)
                  v-icon(left small) mdi-certificate
                  span {{student.number}}
          v-list-item-action
            v-icon(color="primary") mdi-arrow-right

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GroupViewStudentsTab',
  props: {
    groupId: {
      type: Number,
      default: 0,
    },
    courseId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      curatorIds: [],
      headers: [
        { text: 'ФИО', value: 'fio' },
        { text: 'Сертификат', value: 'name' },
        { text: 'Действия', value: 'actions', align: 'end' },
      ],
      loading: false,
      students: [],
      groups: [],
      selectedUsers: [],
    };
  },
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
    }),
    isCurator() {
      return this.curatorIds.includes(this.$user.data.id);
    },
  },
  created() {
    this.fetchCourators();
  },
  mounted() {
    this.getStudents();
  },
  methods: {
    async fetchCourators() {
      const { items } = await this.$api.users.index({
        'search[curator_course_id]': this.courseId,
      });
      this.curatorIds = items.map((i) => i.id);
    },
    getStudents() {
      this.loading = true;
      this.$rHandler(
        this.$api.groups.getGroupStudents(this.groupId),
        (r) => {
          this.students = r.data.data;
          this.students.forEach((s) => this.$set(s, 'showDeleteDialog', false));
          this.loading = false;
          this.getCourseGroups(this.courseId);
        },
        () => {
          this.loading = false;
        },
      );
    },
    getCourseGroups(courseId) {
      this.loading = true;
      const params = {};
      params['search[teacher]'] = this.userData.id;
      this.$rHandler(
        this.$api.courses.getCourseGroupList(courseId, params),
        (r) => {
          this.loading = false;
          this.groups = r.data.data;
        },
      );
    },
    onUsersTransfer(userIds) {
      this.students = this.students.filter((s) => !userIds.includes(s.id));
    },
    onUsersDelete(userIds) {
      this.onUsersTransfer(userIds);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
